import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useAcceptInvitation, useMe } from '../../api/queries';
import { Alert, Loading } from '../../components/ui';
import { buttonClass } from '../../components/ui/button-class';
import { errorMessage } from '../../i18n/labels';
import { AuthLayout } from '../auth/AuthLayout';

/** Invitation link target (FR-ACC-05); the user is signed in by RequireAuth first. */
export function AcceptInvitationPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get('token');
  const accept = useAcceptInvitation();
  const me = useMe();
  const navigate = useNavigate();
  const started = useRef(false);
  const { mutate } = accept;

  useEffect(() => {
    if (!token || started.current) return;
    started.current = true;
    mutate(token, { onSuccess: (r) => void navigate(`/w/${r.workspaceId}`, { replace: true }) });
  }, [token, mutate, navigate]);

  return (
    <AuthLayout title={t('invitation.title')}>
      {!token ? (
        <Alert tone="danger">{t('errors.INVITATION_INVALID')}</Alert>
      ) : accept.error ? (
        <div className="space-y-4">
          <Alert tone="danger">{errorMessage(t, accept.error)}</Alert>
          <p className="text-sm text-slate-600 dark:text-slate-400">
            {t('invitation.signedInAs', { email: me.data?.email ?? '' })}
          </p>
          <Link to="/" className={buttonClass('secondary')}>
            {t('common.backHome')}
          </Link>
        </div>
      ) : (
        <Loading label={t('invitation.accepting')} />
      )}
    </AuthLayout>
  );
}
